import { cn } from '@/lib/utils';
import styles from './PageShell.module.css';

interface PageShellProps {
  children: React.ReactNode;
  className?: string;
  /** Fill the main content area so nested DataTables can scroll internally. */
  fill?: boolean;
}

export function PageShell({ children, className, fill = false }: PageShellProps) {
  return (
    <div data-fill={fill ? '' : undefined} className={cn(fill ? styles.fill : styles.stack, className)}>
      {children}
    </div>
  );
}

/** Toolbar + table region below a page header on fill layouts. */
export function TablePageBody({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn(styles.tableBody, className)}>{children}</div>;
}

/** Filter row above a DataTable — padding (not negative margin) keeps focus rings inside clippers. */
export function TablePageToolbar({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn(styles.toolbar, className)}>{children}</div>;
}
